import {IOffer} from "./Offer";

interface IOfferDetailsProps {
    offer: IOffer
}

export default function OfferDetailsView(props: IOfferDetailsProps) {
    return <div className="Offer_details_view">
        {
            props.offer.details.map((detail) => {
                return <div className="Offer_details_item">
                    <div className="Offer_details_item_dot_container">
                        <div className="Offer_details_item_dot" style={{backgroundColor: props.offer.color}}/>
                    </div>
                    <div className="Offer_details_item_title">{detail}</div>
                </div>
            })
        }
    </div>
}